import { createRouter, createWebHashHistory } from 'vue-router';

import Home from '../views/index.vue';
import store from '../store';

// Vue.use(VueRouter);
// import { createApp } from 'vue';
// const app = createApp();
// app.use(createRouter);

const routes = [
    //dashboard
    {
        path: '/',
        name: 'login',
        component: () => import('../views/login.vue'),
        meta: { layout: 'auth' },
    },
    { path: '/home', name: 'Home', component: Home },


  {
        path: '/patients',
        name: 'patients',
        component: () => import('../views/patients'),
    },

    
  {
        path: '/patient-files/:patient_id',
        name: 'patient-files',
        component: () => import('../views/patients/files.vue'),
    },

      {
        path: '/products',
        name: 'products',
        component: () => import('../views/products'),
    },



    {
        path: '/bulk-statements',
        name: 'bulk-statements',
        component: () => import('../views/distribution/bulk_statements.vue'),
    },
    {
        path: '/machine-statement/:distribution_id',
        name: 'machine-statement',
        component: () => import('../views/distribution/machine_statement.vue'),
    },

    {
        path: '/assets/machines',
        name: 'assets-machines',
        component: () => import('../views/assets/machines.vue'),
    },

    {
        path: '/bulk-distribution/:project_id',
        name: 'bulk',
        component: () => import('../views/distribution/bulk_distribution.vue'),
    },

    {
        path: '/direct-filling/',
        name: 'direct-filling',
        component: () => import('../views/distribution/direct_fill.vue'),
    },



    {
        path: '/direct-fill-statement/:distribution_id',
        name: 'direct-fill-statement',
        component: () => import('../views/distribution/direct_fill_statement.vue'),
    },

  {
        path: '/jobcard/:jobcard_id/:machine_id',
        name: 'jobcard',
        component: () => import('../views/jobcards/jobcard.vue'),
    },
    {
        path: '/jobcards',
        name: 'jobcards',
        component: () => import('../views/jobcards/jobcard_list.vue'),
    },

     {
        path: '/jobcards/outside-maintenances',
        name: 'jobcards-outside-maintenances',
        component: () => import('../views/jobcards/outsideMaintenances.vue'),
    },

        {
        path: '/jobcards/asset-consumption',
        name: 'jobcards-asset-consumption',
        component: () => import('../views/jobcards/assetConsumption.vue'),
    },
    {
        path: '/orders',
        name: 'orders',
        component: () => import('../views/orders/preview.vue'),
    },

       {
        path: '/requisitions',
        name: 'requisitions',
        component: () => import('../views/requisitions/index.vue'),
    },

           {
        path: '/requisitions/:status_id',
        name: 'requisitions',
        component: () => import('../views/requisitions/index.vue'),
    },

      {
        path: '/requisition/:type/:type_id',
        name: 'requisition-type',
        component: () => import('../views/requisitions/typeRequisition.vue'),
    },

    //        {
    //     path: '/good-issue-notes',
    //     name: 'good-issue-notes',
    //     component: () => import('../views/orders/goodIssueNote.vue'),
    // },



       {
        path: '/good-issue-notes',
        name: 'good-issue-notes',
        component: () => import('../views/goodIssueNotes'),
    },

               {
        path: '/good-delivery-notes',
        name: 'good-delivery-notes',
        component: () => import('../views/orders/goodDeliveryNote.vue'),
    },


      {
        path: '/bushman/orders',
        name: 'bushman-orders',
        component: () => import('../views/orders/bushman/'),
    },
    
        {
        path: '/general/orders',
        name: 'general-orders',
        component: () => import('../views/orders/general/'),
    },

    {
        path: '/copex-order-items/:order_id',
        name: 'copex-order-items',
        component: () => import('../views/orders/copex_items_list.vue'),
    },



       {
        path: '/masters/ai',
        name: 'masters-ai',
        component: () => import('../views/masters/ai.vue'),
    },

        {
        path: '/masters/approval-groups',
        name: 'masters-approval-groups',
        component: () => import('../views/masters/approvalManagement/approvalGroups.vue'),
    },
                {
        path: '/masters/approval-check',
        name: 'masters-approval-check',
        component: () => import('../views/masters/approvalCheck.vue'),
    },

      {
        path: '/approval-chains/:group_id',
        name: 'approval-chains',
        component: () => import('../views/approvalChain/'),
    },
    


            {
        path: '/masters/labours',
        name: 'masters-labours',
        component: () => import('../views/masters/labour.vue'),
    },

                {
        path: '/masters/labour-request',
        name: 'masters-labour-request',
        component: () => import('../views/masters/labourRequest.vue'),
    },


        {
        path: '/masters/labour-type',
        name: 'masters-labour-type',
        component: () => import('../views/masters/labourType.vue'),
    },

    
        {
        path: '/masters/lpo-items',
        name: 'masters-lpo-items',
        component: () => import('../views/masters/lpoItems.vue'),
    },

    {
        path: '/masters/machines',
        name: 'masters-machines',
        component: () => import('../views/masters/machines.vue'),
    },

      {
        path: '/masters/machine-type',
        name: 'masters-machine-type',
        component: () => import('../views/masters/machine_type.vue'),
    },

    {
        path: '/masters/service',
        name: 'masters-service',
        component: () => import('../views/masters/service.vue'),
    },
    {
        path: '/masters/vendors',
        name: 'masters-vendors',
        component: () => import('../views/masters/vendors.vue'),
    },
    {
        path: '/masters/employees',
        name: 'masters-employees',
        component: () => import('../views/masters/employees.vue'),
    },

    {
        path: '/masters/items-list',
        name: 'masters-items',
        component: () => import('../views/masters/items/dashboard.vue'),
    },

        {
        path: '/masters/item-categories',
        name: 'masters-item-categories',
        component: () => import('../views/masters/items/category.vue'),
    },

      {
        path: '/masters/logs',
        name: 'masters-logs',
        component: () => import('../views/masters/logs.vue'),
    },
    {
        path: '/masters/units',
        name: 'masters-units',
        component: () => import('../views/masters/units.vue'),
    },
    {
        path: '/masters/users',
        name: 'masters-users',
        component: () => import('../views/masters/users.vue'),
    },
    {
        path: '/masters/role',
        name: 'masters-roles',
        component: () => import('../views/masters/role.vue'),
    },

    {
        path: '/masters/role-permissions',
        name: 'masters-role-permissions',
        component: () => import('../views/masters/rolePermissions.vue'),
    },


    
    {
        path: '/masters/permissions',
        name: 'masters-permission',
        component: () => import('../views/masters/permission.vue'),
    },

    {
        path: '/masters/projects',
        name: 'masters-projects',
        component: () => import('../views/masters/projects.vue'),
    },

        {
        path: '/masters/remark-records',
        name: 'masters-remark-records',
        component: () => import('../views/masters/remark_records.vue'),
    },

    {
        path: '/user/profile',
        name: 'user-profile',
        component: () => import('../views/user/profile.vue'),
    },
   

      {
        path: '/chats',
        name: 'system-chats',
        component: () => import('../views/chats/dashboard.vue'),
    },




    {
        path: '/assets/spares',
        name: 'assets-spares',
        component: () => import('../views/assets/spares_list.vue'),
    },


     {
        path: '/report/item-budget/:project_id/:budget_id',
        name: 'item-budget-report',
        component: () => import('../views/report/item_budget.vue'),
    },

    {
        path: '/budgets',
        name: 'budgets',
        // component: () => import('../views/budgets/index.vue'),
        component: () => import('../views/test/budget.vue'),

    },

         {
        path: '/report/workReport',
        name: 'Work Report',
        component: () => import(/* webpackChunkName: "components-tabs" */ '../views/report/workReport.vue'),
    },

    {
  path: '/report/Report/:store_id',
  name: 'Report',
  component: () => import('../views/report/Report.vue'),
  props: true
},

        {
        path: '/test',
        name: 'test',
        component: () => import('../views/test/budget.vue'),
    },

     {
        path: '/budget-analysis',
        name: 'budget-analysis',
        component: () => import('../views/budgets/analysis.vue'),
    },

    {
        path: '/report/project-budgets/:project_id',
        name: 'project-budgets-report',
        component: () => import('../views/report/projectBudgets.vue'),
    },

    {
        path: '/report/machine-usage/:machine_id',
        name: 'machine-usage-report',
        component: () => import('../views/report/machine_report.vue'),
    },
{
    path: '/report/site-report',
    name: 'site-report',
    component: () => import('../views/report/site_report.vue'),
},
{
    path: '/report/boq',
    name: 'boq-report',
    component: () => import('../views/report/boq.vue'),
},

{
    path: '/report/allowance',
    name: 'allowance-report',
    component: () => import('../views/report/allowance.vue'),
},

{
    path: '/report/allowance-approved/:project_id/:request_id/:date',
    name: 'allowance-approved-report',
    component: () => import('../views/report/allowanceApproved.vue'),
},

{
    path: '/report/allocation',
    name: 'allocation-report',
    component: () => import('../views/report/allocation.vue'),
},
    {
        path: '/voucher',
        name: 'voucher',
        component: () => import('../views/voucher/index.vue'),
    },

     {
        path: '/payment',
        name: 'payment',
        component: () => import('../views/payment/index.vue'),
    },


      {
        path: '/labour-request',
        name: 'labour-request',
        component: () => import('../views/labours/labour_request.vue'),
    },
// 25 june 2025

      {
        path: '/good-received-notes/dashboard',
        name: 'good-received-notes-dashboard',
        component: () => import('../views/goodReceivedNotes/dashboard.vue'),
    },

        {
        path: '/stores/dashboard',
        name: 'stores-dashboard',
        component: () => import('../views/stores/dashboard.vue'),
    },

       {
        path: '/stores/return-notes/:store_id',
        name: 'stores-return-notes',
        component: () => import('../views/stores/returnNotes.vue'),
    },
        {
        path: '/logs/deleted-orders',
        name: 'logs-deleted-orders',
        component: () => import('../views/logs/deletedOrders.vue'),
    },
            {
        path: '/test/budget',
        name: 'test-budget',
        component: () => import('../views/test/budget.vue'),
    },



  

];

const router = new createRouter({
    // mode: 'history',
    history: createWebHashHistory(),
    linkExactActiveClass: 'active',
    routes,
    scrollBehavior(to, from, savedPosition) {
        if (savedPosition) {
            return savedPosition;
        } else {
            return { left: 0, top: 0 };
        }
    },
});

router.beforeEach((to, from, next) => {
    if (to.meta && to.meta.layout && to.meta.layout == 'auth') {
        store.commit('setLayout', 'auth');
    } else {
        store.commit('setLayout', 'app');
    }
    next(true);
});

export default router;
